import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { AppComponent } from './../../../app.component';
import { AuthService } from '../../services/auth.service';
import { UserContextService } from '../../services/user-context.service';
import { UsuariosService } from 'app/api/usuarios.service';
import { User } from 'app/model/user';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit, OnDestroy {

  systemVersion: string;
  year: number;
  loginForm: FormGroup;
  esqueciSenhaForm: FormGroup;
  submitted = false;
  submittedReset = false;
  send = false;
  buttonWait = false;
  sendError: string = null;

  verificaUsuario$: Observable<User>;

  currentBgIndex = 1;
  private intervalId: any;

  private returnUrl: string = '/home'; // Rota padrão caso não haja returnUrl
  private btn: any;
  private input: any;

  private subs = new SubSink();

  constructor(
    private authService: AuthService,
    private userContext: UserContextService,
    private usuariosService: UsuariosService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private appComponent: AppComponent) { }

  ngOnInit() {

    this.startBgRotation();

    this.loginForm = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(3)]]
    });

    this.esqueciSenhaForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';

    if (this.authService.isLoggedIn()) {
      this.router.navigateByUrl(this.returnUrl);
      // this.router.navigate(['/home']);
    }

    this.year = new Date().getFullYear();
    this.systemVersion = this.authService.sysVersion();
    this.btn = document.querySelector('.fa-eye');
    this.input = document.querySelector('#password');

  }

  get f() { return this.loginForm.controls; }
  get r() { return this.esqueciSenhaForm.controls; }

  login() {

    this.submitted = true;
    if (this.loginForm.invalid) return; 

    const boxLogin = document.getElementById('boxLoginForm');
    const animationLogin = document.getElementById('animationSubmit');

    boxLogin.classList.add('d-none');
    animationLogin.classList.remove('d-none');

    this.subs.sink = this.authService.post({ userName: this.f.userName.value, password: this.f.password.value })
      .subscribe({
        next: (success) => {
          if (success) {
            if (this.authService.checkTokenAccess) {
              this.getUsuarioLogado(boxLogin, animationLogin); // Passando os elementos para tratar o loading
              this.authService.checarCronometroToken();
            } else {
              this.resetLoading(boxLogin, animationLogin);
            }
          } else {
            this.resetLoading(boxLogin, animationLogin);
          }
        },
        error: (err) => {
          this.resetLoading(boxLogin, animationLogin);
          console.error('Erro no login:', err);
        }
      });
  }

  private getUsuarioLogado(boxLogin: HTMLElement, animationLogin: HTMLElement) {
    // Inserindo a requisição dentro do gerenciador de subscrições (SubSink)
    this.subs.sink = this.usuariosService.v1UsuariosLogadoGet()
      .subscribe({
        next: (usuarioLogado) => {
          if (usuarioLogado) {
            // console.log('Usuario', usuarioLogado);
            localStorage.setItem('User', usuarioLogado.userName);
            
            const role = usuarioLogado.roles.includes('Administrador') ? 'admin' : usuarioLogado.pessoaJuridicaId.toString();
            localStorage.setItem('userRole', role);
          } else {
            localStorage.setItem('User', null);
            localStorage.setItem('userRole', '0');
          }
          
          this.userContext.user = usuarioLogado;
          this.appComponent.ngOnInit();

          this.resetLoading(boxLogin, animationLogin);

          // ✅ AGORA SIM: O redirecionamento ocorre estritamente APÓS o sucesso da gravação dos dados
          this.router.navigateByUrl(this.returnUrl);
        },
        error: (err) => {
          this.resetLoading(boxLogin, animationLogin);
          console.error('Erro ao buscar usuário logado', err);
        }
      });
  }

  // Método auxiliar para limpar a animação de loading do formulário
  private resetLoading(box: HTMLElement, animation: HTMLElement) {
    box?.classList.remove('d-none');
    animation?.classList.add('d-none');
  }

  viewPass() {
    this.btn.addEventListener('mouseenter', () => {
      if (this.input.getAttribute('type') === 'password') {
        this.input.setAttribute('type', 'text');
      }
    });
    this.btn.addEventListener('mouseleave', () => {
      this.input.setAttribute('type', 'password');
    });
  }

  esqueciSenha() {
    this.submittedReset = true;

    if (this.esqueciSenhaForm.invalid) return; 

    this.buttonWait = true;

    let emailReset = this.esqueciSenhaForm.value.email;

    this.subs.sink = this.usuariosService.v1UsuariosEsqueciSenhaGet(emailReset)
    .subscribe(success => {
      this.send = true;
      this.submittedReset = false;
      this.buttonWait = false;
    }, error => {
      this.sendError = error;
      this.submittedReset = false;
      this.buttonWait = false;
    })
  }

  resetFormEsqueci() {
    this.send = false;
    this.sendError = null;
    this.submittedReset = false;
    this.buttonWait = false;
    this.esqueciSenhaForm.setValue({
      email: null
    });
  }

  startBgRotation() {
    // Evita loop descontrolado usando setInterval limpo
    this.intervalId = setInterval(() => {
      // Garante que a próxima imagem seja diferente da atual para fazer sentido o efeito
      let nextIndex;
      do {
        nextIndex = Math.floor(Math.random() * 4) + 1;
      } while (nextIndex === this.currentBgIndex);

      this.currentBgIndex = nextIndex;
    }, 5000);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.subs.unsubscribe();
  }


}

